import "./index.css";
import React from "react";
import moment from "moment";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import AddEventModal from "./AddEventModal";
import AddEvent from "./components/AddEvent";
import EventCard from "./EventCard";
import EditEvent from "./components/EditEvent";
import ConfirmationModal from "../../components/ConfirmationModal";

class Event extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: true,
      events: [],
      articles: [],
      hotTopicTags: [],
      products: [],
      current_past: "current",
      eventToEdit: {},
      editingEventId: "",
    };
    this.deleteEventBtnRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (!brand_data) return;
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          territory: brand_data.territory,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          white: brand_data.white,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
          is_supportchat_needed: brand_data.is_supportchat_needed
            ? brand_data.is_supportchat_needed
            : false,
          is_programmetool_need: brand_data.is_programmetool_need
            ? brand_data.is_programmetool_need
            : false,
        });
        Firebase.getAllEvents(brand_data.name, (events) => {
          // let Ev = events.filter((e) => e.time);
          this.setState({ events: events, loading: false });
        });
        Firebase.getArticlesByBrand(brand_data.name, (articles) =>
          this.setState({ articles })
        );
        Firebase.getAllHotTopics(brand_data.name, (hot_topics) => {
          let hot_topic_tags = hot_topics.map((topic) => {
            let label = `${topic.starting_monday
              .toDate()
              .toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
              })} - ${topic.tag}`;
            let value = topic;
            return { label, value };
          });
          this.setState({ hotTopicTags: hot_topic_tags });
        });
        if (brand_data && brand_data.packages) {
          const packages = brand_data.packages;
          let bPckgs_ids = Object.keys(brand_data.packages);
          const pkgs = bPckgs_ids.map((id) => ({ ...packages[id], id }));
          const products = [...pkgs.filter((item) => item.active)];
          this.setState({ products });
        }
      });
    }
  }
  isExpired = (event) => {
    if (!event.isrecurring && moment().isAfter(event.time)) {
      return true;
    }
    return false;
  };
  renderContent = () => {
    const { events, current_past, hex, white } = this.state;
    return (
      <div className="event-content">
        <div className="row-div">
          <button
            className={`btn btn-white`}
            style={{
              backgroundColor: current_past === "current" ? hex : "white",
              color:
                current_past === "current"
                  ? white
                    ? "white"
                    : "black"
                  : "black",
            }}
            onClick={() => this.setState({ current_past: "current" })}
          >
            Current events
          </button>
          <button
            className={`btn btn-white`}
            style={{
              backgroundColor: current_past === "past" ? hex : "white",
              color:
                current_past === "past" ? (white ? "white" : "black") : "black",
            }}
            onClick={() => this.setState({ current_past: "past" })}
          >
            Past events
          </button>
        </div>
        <div className="event-items">
          {events
            .filter((event) =>
              current_past === "current"
                ? !this.isExpired(event)
                : this.isExpired(event)
            )
            .map((item, index) => (
              <React.Fragment key={index}>
                <EventCard
                  item={item}
                  key={item.id}
                  hex={hex}
                  white={white}
                  onEditEvent={() => {
                    this.onEditEvent(item);
                    if (item.id) {
                      this.setState({ editingEventId: item.id });
                    }
                  }}
                />
              </React.Fragment>
            ))}
          <button
            className="btn-add btn-brand-hex"
            style={{
              backgroundColor: "white",
              color: "black",
              "--hover-text-color": white ? "white" : "black",
              "--hover-color": hex,
            }}
            data-toggle="modal"
            data-target="#add_event_modal"
          >
            <p style={{ fontSize: "65px", lineHeight: "65px" }}>+</p>
            <p className="event-item-text">Add a new event</p>
          </button>
        </div>
      </div>
    );
  };

  createEvent = async (payload) => {
    const {
      title,
      address,
      isrecurring,
      token,
      day,
      start_time,
      end_time,
      type,
      date,
      time,
      description,
      media_type,
      media_url,
      purchaseType,
      redemptionType,
      price,
      article,
      hotTopicTag,
      productTag,
    } = payload;
    let { brand_name, events } = this.state;
    let event = {
      title,
      type,
      address,
      description,
      start_time,
      end_time,
      isrecurring,
      token,
      media_type,
      media_url,
      purchaseType,
      redemptionType,
      price,
      article,
      hotTopicTag,
      productTag,
    };
    if (isrecurring) event.day = day;
    else {
      event.date = date;
      event.time = time;
    }
    Firebase.addEvent(event, brand_name).then((res) => {
      Firebase.getAllEvents(brand_name, (events) => {
        this.setState({ events: events, loading: false });
      });
    });
  };

  updateEvent = async (id, payload) => {
    const {
      title,
      address,
      isrecurring,
      token,
      day,
      start_time,
      end_time,
      type,
      date,
      time,
      description,
      media_type,
      media_url,
      purchaseType,
      redemptionType,
      price,
      article,
      hotTopicTag,
      productTag,
    } = payload;
    let { brand_name, events, editingEventId } = this.state;
    let event = {
      title,
      type,
      address,
      description,
      start_time,
      end_time,
      isrecurring,
      token,
      media_type,
      media_url,
      purchaseType,
      redemptionType,
      price,
      article,
      hotTopicTag,
      productTag,
    };
    if (isrecurring) event.day = day;
    else {
      event.date = date;
      event.time = time;
    }
    Firebase.updateEvent(brand_name, editingEventId, event).then((res) => {
      Firebase.getAllEvents(brand_name, (events) => {
        // let Ev = events.filter((e) => e.time);
        this.setState({ events: events, loading: false });
      });
    });
  };

  deleteEvent = () => {
    const { brand_name, editingEventId } = this.state;
    Firebase.deleteEvent(brand_name, editingEventId);
    Firebase.getAllEvents(brand_name, (events) => {
      this.setState({ events: events, loading: false });
    });
  };

  onEditEvent = (item) => {
    this.setState({ eventToEdit: item });
  };
  render() {
    const {
      username,
      role,
      loading,
      logo,
      brand,
      brand_name,
      is_property_brand,
      territory,
      articles,
      hotTopicTags,
      products,
      eventToEdit,
      hex,
      white,
    } = this.state;

    return (
      <div id="page-container" className="event-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && this.renderContent()}
          <AddEventModal
            createEvent={this.createEvent}
            territory={territory}
            articles={articles}
            hex={hex}
            white={white}
          />
          <AddEvent
            createEvent={this.createEvent}
            articles={articles}
            hotTopicTags={hotTopicTags}
            products={products}
            hex={hex}
            white={white}
          />
          <EditEvent
            updateEvent={this.updateEvent}
            articles={articles}
            hotTopicTags={hotTopicTags}
            products={products}
            currentEvent={eventToEdit}
            deleteEvent={this.deleteEvent}
            deleteEventBtnRef={this.deleteEventBtnRef}
            hex={hex}
            white={white}
          />
          <ConfirmationModal
            id="delete_event"
            type="event"
            onClick={this.deleteEvent}
            hex={hex}
            white={white}
          />
          <button
            style={{ display: "none" }}
            ref={this.deleteEventBtnRef}
            data-toggle="modal"
            data-target="#delete_event"
          />
        </main>
      </div>
    );
  }
}

export default Event;



// WEBPACK FOOTER //
// ./src/screens/Event/index.js